import { Banner, LegacyCard, Text } from '@shopify/polaris'

export const UpgradeToAccessCard = ({ children }: { children: any }) => (
  <LegacyCard sectioned>
    <Banner tone="warning">
      <Text as="p">{children}</Text>
    </Banner>
  </LegacyCard>
)
